// The rules a run changed, one line per rule however many turns touched it.
// Parses the labels completion._change_label writes: "<verb> R31 - <title>".
const LABEL = /^(\w+) (R(\d+)) - (.*)$/;
const VERB_ORDER = ["added", "updated", "retired"];

export interface AppliedRule {
  id: string;
  title: string;
  verbs: string;
}

export const appliedRuleChanges = (labels: readonly string[]): AppliedRule[] => {
  const byId = new Map<string, { n: number; title: string; verbs: Set<string> }>();
  const unparsed: AppliedRule[] = [];
  for (const label of labels) {
    const m = LABEL.exec(label);
    if (!m) {
      if (!unparsed.some((u) => u.title === label)) {
        unparsed.push({ id: "", title: label, verbs: "" });
      }
      continue;
    }
    const [, verb, id, n, title] = m;
    const entry = byId.get(id) ?? { n: Number(n), title, verbs: new Set<string>() };
    // The latest title wins: an update may have renamed the rule.
    entry.title = title;
    entry.verbs.add(verb);
    byId.set(id, entry);
  }
  const rank = (v: string) => (VERB_ORDER.includes(v) ? VERB_ORDER.indexOf(v) : VERB_ORDER.length);
  return [
    ...[...byId.entries()]
      .sort(([, a], [, b]) => a.n - b.n)
      .map(([id, e]) => ({
        id,
        title: e.title,
        verbs: [...e.verbs].sort((a, b) => rank(a) - rank(b)).join(" and "),
      })),
    ...unparsed,
  ];
};
